<template>
  <div>
    <section class="d-flex justify-content-end align-items-end">
      <b-button
        v-b-modal.auto-sms-modal
        variant="primary"
        @click="openNewAutoSmsModal"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t('generals.add') }}
      </b-button>
    </section>
    <b-card class="mt-2">
      <b-table
        :fields="fields"
        :items="GET_AUTO_MAILS.results"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">
            {{ $t('general.no_records_to_show') }}
          </div>
        </template>

        <template #cell(type_sending)="props">
          {{ period_options.find(el => el.value === props.item.type_sending).text }}
        </template>
        <template #cell(whom)="props">
          <b-badge
            v-if="!Object.keys(props.item.whom).length"
            variant="info"
          >
            {{ $t('sms.to_all') }}
          </b-badge>
          <b-badge
            v-for="(val, key) in parameters(props.item.whom)"
            v-else
            :key="key"
            variant="info"
            class="mr-50"
          >
            {{ parameter_fields[key][val][$i18n.locale] }}
          </b-badge>
        </template>
        <template #cell(actions)="props">
          <div class="d-flex justify-content-around">
            <!-- <b-button
              v-b-modal.constructor-modal
              variant="info"
              size="sm"
              @click="showHistory(props.item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button> -->
            <b-button
              v-b-modal.auto-sms-modal
              variant="warning"
              size="sm"
              @click="editAutoSms(props.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deleteAutoSms(props.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-75 shadow rounded bg-white p-1">
        <div class="d-flex align-items-center mb-0">
          <span class="text-nowrap text-black ml-1">
            {{ $t('generals.show_from') }}
          </span>
          <b-form-select
            v-model="query_params.page_size"
            :options="['5','10','15']"
            class="mx-1 text-black"
            @change="refresh"
          />
        <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
        </div>
        <div class="mb-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="GET_AUTO_MAILS.count"
            :per-page="query_params.page_size"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @change="changePage"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>
    <auto-sms-modal
      :is-edit="editing"
      :def-obj="selected_auto_sms"
      @success="refresh"
    />
  </div>
</template>

<script>
import {
  BCard, BTable, BButton, VBModal, BBadge, BPagination, BFormSelect,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions, mapGetters } from 'vuex'
import autoSmsModal from './components/autoSmsModal.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BBadge,
    FeatherIcon,
    autoSmsModal,
    BPagination,
    BFormSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      query_params: {
        search: '',
        page: 1,
        page_size: 10,
      },
      currentPage: 1,
      editing: false,
      selected_auto_sms: {
        whom: {
          // nds: 15,
        },
        type_sending: 'annual',
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'width-50',
        },
        {
          key: 'title',
          label: 'generals.name',
        },
        {
          key: 'template',
          label: 'sms.template',
          formatter(val) {
            if (typeof val === 'number' || !val) {
              return val
            }
            return val.title
          },
        },
        {
          key: 'type_sending',
          label: 'sms.frequency',
        },
        {
          key: 'whom',
          label: 'sms.client_parameters',
        },
        {
          key: 'actions',
          label: 'sms.actions',
          class: 'width-200',
        },
      ],
      entityOptions: [
        {
          title: this.$t('sms.legal_entity'),
          id: 'yuridiskiy',
        },
        {
          title: this.$t('sms.natural_person'),
          id: 'fizichiskiy',
        },
      ],
      genderOptions: [
        {
          title: {
            uz: 'Erkak',
            ru: 'Мужской',
            en: 'Male',
          },
          id: 'man',
        },
        {
          title: {
            uz: 'Ayol',
            ru: 'Женский',
            en: 'Female',
          },
          id: 'woman',
        },
      ],
      period_options: [
        { text: this.$t('sms.annual'), value: 'annual' },
        { text: this.$t('sms.once_quarterly'), value: 'quarter' },
        { text: this.$t('sms.once_monthly'), value: 'monthly' },
      ],
      parameter_fields: {
        gender: {
          man: {
            uz: 'Erkak',
            ru: 'Мужчина',
          },
          woman: {
            uz: 'Ayol',
            ru: 'Женщина',
          },
        },
        entity: {
          fizichiskiy: {
            uz: 'Jismoniy shaxs',
            ru: 'Физическое лицо',
          },
          yuridiskiy: {
            uz: 'Yurisik shaxs',
            ru: 'Юридическое лицо',
          },
        },
      },
      timeout: 600,
    }
  },
  computed: {
    ...mapGetters('sms', ['GET_AUTO_MAILS']),
    ...mapGetters('knowledgeBase', ['GET_MONTHS']),
  },
  mounted() {
    this.FETCH_AUTO_MAILS()
  },
  methods: {
    ...mapActions('sms', ['FETCH_AUTO_MAILS', 'DELETE_AUTO_SMS']),
    refresh() {
      this.$bvModal.hide('auto-sms-modal')
      this.selected_auto_sms = {
        whom: {
        },
        type_sending: 'annual',
      }
      this.FETCH_AUTO_MAILS(this.query_params)
    },
    editAutoSms(auto_sms) {
      this.editing = true
      const { template, ...rest } = this.$_removeObjectConnection(auto_sms)
      this.selected_auto_sms = {
        template: typeof template === 'number' ? template : template.id,
        ...rest,
      }
      if (!Object.keys(auto_sms.whom).length) {
        this.selected_auto_sms.all = true
      }
    },
    openNewAutoSmsModal() {
      this.editing = false
      this.selected_auto_sms = {
        whom: {
          // nds: 15,
        },
        type_sending: 'annual',
      }
    },
    deleteAutoSms(id) {
      this.$_showAreYouSureModal().then(res => {
        if (res) {
          this.DELETE_AUTO_SMS(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
    parameters(parameters) {
      if (!Object.keys(parameters).length) {
        return true
      }
      return parameters
    },
    changePage(value) {
      this.currentPage = value
      this.refresh()
    },
    getFullDate(sms) {
      if (sms.type_sending === 'annual') {
        const period_month = sms.when.split('-')
        const month_name = this.GET_MONTHS.find(el => el.id === Number(period_month[1]))
        return `${period_month[0]}-${month_name.title[this.$i18n.locale]}`
      } if (sms.type_sending === 'monthly') {
        return ''
      } return ''
    },
  },
}
</script>

<style>

</style>
